// src/components/profile/ProfileHeader.jsx
import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import defaultAvatar from '../../assets/images/default-avatar.svg';

const ProfileHeader = ({ userData, isOwnProfile, handleShare, copySuccess, handleProfilePictureUpload, previewImage }) => {
  
  // Debug function to ensure the handler is working
  const debugFileChange = (e) => {
    console.log('File input changed!', e.target.files);
    console.log('handleProfilePictureUpload function:', handleProfilePictureUpload);
    
    if (handleProfilePictureUpload) {
      handleProfilePictureUpload(e);
    } else {
      console.error('handleProfilePictureUpload is not defined!');
    }
  };

  return (
    <>
      {/* Profile Header with Banner */}
      <div className="h-56 bg-gradient-to-r from-blue-900/80 via-indigo-900/80 to-purple-900/80 relative overflow-hidden">
        {/* Banner Pattern Overlay */}
        <div className="absolute inset-0 opacity-20">
          <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none">
            <defs>
              <pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse">
                <path d="M 10 0 L 0 0 0 10" fill="none" stroke="white" strokeWidth="0.5" />
              </pattern>
            </defs>
            <rect width="100" height="100" fill="url(#grid)" />
          </svg>
        </div>

        {/* Back to Forum Button */}
        <div className="absolute top-4 left-4">
          <Link
            to="/forum"
            className="bg-gray-800/80 hover:bg-gray-700 text-white px-4 py-2 rounded-md flex items-center transition-all duration-200 backdrop-blur-sm"
          >
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Back to Forum
          </Link>
        </div>

        {/* Share Button */}
        <div className="absolute top-4 right-4 flex space-x-3">
          <button
            onClick={handleShare}
            className="bg-gray-800/80 hover:bg-gray-700 text-white px-4 py-2 rounded-md flex items-center transition-all duration-200 backdrop-blur-sm"
          >
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
            </svg>
            Share Profile
          </button>
        </div>

        {/* Copy Success Notification */}
        <AnimatePresence>
          {copySuccess && (
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.3 }}
              className="absolute top-16 right-4 bg-green-600/90 backdrop-blur-sm text-white px-4 py-2 rounded-md shadow-lg flex items-center z-50"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              Profile link copied!
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      {/* Profile Picture - Moved outside the banner */}
      <div className="relative max-w-6xl mx-auto px-6">
        <div className="absolute -top-16 left-8 z-10">
          <div className="h-32 w-32 rounded-full border-4 border-[#0B0C0D] bg-gray-800 overflow-hidden shadow-lg relative">
            <img
              src={previewImage || userData.profilePicture || defaultAvatar}
              alt={userData.display_name}
              className="h-full w-full object-cover"
            />

            {isOwnProfile && (
              <div className="absolute inset-0">
                <input
                  type="file"
                  accept="image/*"
                  className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-20"
                  onChange={debugFileChange}
                  onClick={(e) => {
                    console.log('File input clicked!');
                    // Reset the input value to allow selecting the same file again
                    e.target.value = '';
                  }}
                />
                <div className="absolute inset-0 bg-black/50 opacity-0 hover:opacity-100 flex items-center justify-center transition-opacity duration-200 cursor-pointer z-10">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfileHeader;